import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ApiResponse } from '../shared/types';
import type {
  FamilyPlanSettingsData,
  FamilyPlanSettingsPayload,
} from '../shared/types/family-plan-settings.types';

@Injectable({ providedIn: 'root' })
export class FamilyPlanSettingsService {
  constructor(private api: ApiService) {}

  getSettings(locationId: string): Observable<ApiResponse<FamilyPlanSettingsData>> {
    return this.api.get<FamilyPlanSettingsData>('order/family-plan-settings', {
      location_id: locationId,
    }) as Observable<ApiResponse<FamilyPlanSettingsData>>;
  }

  saveSettings(
    payload: FamilyPlanSettingsPayload
  ): Observable<ApiResponse<FamilyPlanSettingsData>> {
    return this.api.put<FamilyPlanSettingsData>(
      'order/family-plan-settings',
      payload
    ) as Observable<ApiResponse<FamilyPlanSettingsData>>;
  }
}
